export default "__VITE_ASSET__CtzOolxD__"